module.exports = __webpack_public_path__ + "img/lamp_bh.651da0ce.png";